<!-- Latest Tweet -->
<div class="mb-4">
   <h4 class="sidebar-title mb-3">Latest Tweets</h4>
</div>
<div class="media mb-3" *ngFor="let tweet of tweets">
    <div class="d-flex mr-2 text-primary pt-1"><i class="fa {{tweet?.icon}} fa-lg"></i> </div>
    <div class="media-body" [innerHTML]="tweet?.content"></div>
</div>

